<template>
  <div class="content-box">
    <div class="row">
      <div class="col-lg-12">
        <div class="element-wrapper" v-if="tarima.id != null">
          <div class="element-box">
            <div class="padded-lg">
              <!--START - Projects list-->
              <button class="btn btn-secondary" type="button" @click="cancelar">
                Regresar
              </button>
              <div class="projects-list">
                <div class="">
                  <div class="project-head">
                    <div class="project-title">
                      <h5>Tarima</h5>
                      <div
                        class="badge badge-danger"
                        v-if="
                          tarima.fin_detallado &&
                          tarima.tuvo_inconsistencia == true &&
                          tarima.revisado == false
                        "
                      >
                        Tiene Inconsistencia
                      </div>
                      <div
                        class="badge badge-success"
                        v-if="
                          tarima.fin_detallado &&
                          tarima.tuvo_inconsistencia == true &&
                          tarima.revisado == true
                        "
                      >
                      Inconsistencia Resuelta
                      </div>
                    </div>
                  </div>
                  <div class="mt-2">
                    <div class="text-center text-success font-weight-bold">
                      {{ tarima.estado_str }}
                    </div>
                    <div class="text-center"># {{ tarima.numero }}</div>
                    <div class="text-center">{{ tarima.barra }}</div>

                    <div class="text-center">
                      Creado: {{ tarima.fecha_creacion }}
                    </div>
                    <div v-if="tarima.fin_detallado" class="text-center">
                      Detallado: {{ tarima.fin_detallado }}
                    </div>
                    <div class="row align-items-center mt-3">
                      <table class="table table-clean">
                        <tbody>
                          <tr
                            v-for="detalle in tarima.detalle"
                            :key="detalle.id"
                          >
                            <td>
                              <div class="value">
                                {{ detalle.producto_obj.nombre }}
                              </div>
                              <span class="sub-value text-small">
                                {{ detalle.producto_obj.sku }}
                                <br />
                                <small>
                                  Intentos
                                  {{ detalle.intentos_conteo_destino }} de
                                  {{ detalle.intentos_maximos_destino }}
                                </small>
                              </span>
                            </td>
                            <td class="text-right">
                              <div class="value">
                                <h5
                                  class="text-success"
                                  v-if="
                                    detalle.total_enviada ==
                                    detalle.total_recibida
                                  "
                                >
                                  {{ detalle.total_recibida }}
                                </h5>
                                <h5
                                  class="text-danger"
                                  v-if="
                                    detalle.total_enviada !=
                                    detalle.total_recibida
                                  "
                                >
                                  {{ detalle.total_recibida }}
                                </h5>
                              </div>
                              <span class="sub-value">
                                <span
                                  v-for="c in detalle.producto_obj.barras"
                                  :key="c"
                                  >{{ c }}<br
                                /></span>
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <!--END - Projects list-->
            </div>
            <div class="col-12" v-if="error_msg">
              <small class="form-text text-danger">
                {{ error_msg }}
              </small>
            </div>
            <div v-if="tarima.estado == 'F' || tarima.estado == 'G'">
              <ModalContarProductoComponent
                :tarima="tarima"
                v-if="!iniciar_finalizar"
                @refresh_tarima="refresh"
              />
              <div
                class="floated-chat-btn btn-danger third-floated-btn"
                style="background: #e65252; z-index: 1000 !important"
                v-if="iniciar_finalizar"
                @click="finalizarRecepcionDeTarima"
              >
                <i class="fas fa-check-double"></i>&nbsp;Finalizar
              </div>
              <div
                class="floated-colors-btn second-floated-btn"
                @click="iniciarFinalizar"
                style="z-index: 1000 !important"
              >
                <div class="os-toggler-w" :class="{ on: iniciar_finalizar }">
                  <div class="os-toggler-i">
                    <div class="os-toggler-pill"></div>
                  </div>
                </div>
                <span v-if="!iniciar_finalizar">Finalizar</span>
                <span v-if="iniciar_finalizar">Cancelar</span>
              </div>
            </div>
            <button
              v-if="tarima.estado == 'H'"
              class="btn btn-success btn-block"
              type="button"
              @click="imprimir"
            >
              Reporte de Inconsistencias
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import DynamicService from "@/services/commons/DynamicService";
import ModalContarProductoComponent from "@/components/wms/recepciontarima/ModalContarProductoComponent";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    UsuarioEnTablaComponent,
    ModalContarProductoComponent,
  },
  data() {
    return {
      error_msg: null,
      iniciar_finalizar: false,
      tarima: {
        pk: null,
        fecha_llegada: null,
      },
    };
  },
  mounted() {
    this.refreshTarima(this.$route.params.id);
  },
  methods: {
    imprimir() {
      let self = this;
      let id = self.tarima.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=wms/tarima/inconsistencias.jrxml&id=${id}`
      );
      $("#listaPrecio").modal("hide");
    },
    iniciarFinalizar() {
      let self = this;
      self.iniciar_finalizar = !self.iniciar_finalizar;
    },
    formatDatetime(date) {
      if (date == null) {
        return "";
      }
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    cancelar() {
      let self = this;
      self.$router.push({
        name: "wms-recepcion-tarima-buscar",
        params: {},
      });
    },
    refresh() {
      let self = this;
      self.refreshTarima(self.tarima.id);
    },
    refreshTarima(barra) {
      let self = this;
      DynamicService.getById("wms", "tarima", barra)
        .then((res) => {
          self.tarima = res.data;
          self.tarima.fecha_creacion = moment(
            self.tarima.fecha_creacion
          ).format("DD/MM/YYYY hh:mm:s a");
          if (self.tarima.fin_detallado) {
            self.tarima.fin_detallado = moment(
              self.tarima.fin_detallado
            ).format("DD/MM/YYYY hh:mm:s a");
          }
        })
        .catch((err) => {
          if (err.response.data.detail) {
            alert(err.response.data.detail);
            self.$router.push({
              name: "wms-recepcion-tarima-buscar",
              params: {},
            });
          }
        });
    },
    recibirTarima() {
      let self = this;
      DynamicService.postActionList("wms", "tarima", "recepcion_tarima", {
        barra: self.tarima.barra,
      })
        .then((res) => {
          self.refreshTarima(self.tarima.id);
        })
        .catch((err) => {
          console.log(err.response.data);
          if (err.response.data.detail) {
            self.error_msg = err.response.data.detail;
          }
        });
    },
    recibirTarimas() {
      let self = this;
      if (
        self.tarima.fecha_llegada != null &&
        self.tarima.fecha_retorno == null
      ) {
        self.$router.push({
          name: "wms-recepcion-tarima-recepcion",
          params: { id: self.tarima.id },
        });
      } else {
      }
    },
    finalizarRecepcionDeTarima() {
      let self = this;
      Notifications.alert.confirm(
        "¿Esta seguro que quiere hace esto?",
        "Esta acción no se puede regresar",
        "Si finalizar",
        function () {
          DynamicService.postAction(
            "wms",
            "tarima",
            self.tarima.id,
            "finalizar_recepcion"
          )
            .then((res) => {
              self.refreshTarima(self.tarima.id);
              self.iniciar_finalizar = false;
            })
            .catch((err) => {
              self.iniciar_finalizar = false;
              console.log(err.response.data);
              if (err.response.data.detail) {
                self.error_msg = err.response.data.detail;
              }
            });
        }
      );
    },
  },
};
</script>
